import React from 'react';

import {
  ChallengeDetailsModal,
  RemoveIncentiveModalProvider,
  ReplaceIncentiveModalProvider,
} from '../../modals';

export const LoyaltyModalsProvider = ({ children }: { children: React.ReactNode }) => {
  return (
    <ReplaceIncentiveModalProvider>
      <RemoveIncentiveModalProvider>
        {children}
        <ChallengeDetailsModal />
      </RemoveIncentiveModalProvider>
    </ReplaceIncentiveModalProvider>
  );
};
